import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { logEvent } from '../../../lib/gtag';
import { Button, SearchInput } from '@lb-service/ui';
import appUtils from '../../../utils/appUtils';

const ArticlesSidebar = () => {
  // const [searchTerm, updateSearchTerm] = useState('');
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation(['blog', 'common']);
  let bannerUrl;

  switch (locale) {
    case 'ja':
      bannerUrl = '/images/blog_sidebar_banner_ja.gif';
      break;
    case 'es':
      bannerUrl = '/images/blog_sidebar_banner_es.gif';
      break;
    case 'pt':
      bannerUrl = '/images/blog_sidebar_banner_pt.gif';
      break;
    default:
      bannerUrl = '/images/blog_sidebar_banner_en.gif';
      break;
  }

  const onSubmit = (value) => {
    router.push({
      pathname: '/blog',
      query: { search: value },
    });
  };

  // const searchProps = {
  //   placeholder: t('sidebar.search.placeholder'),
  //   className: 'blog-search',
  //   value: searchTerm,
  //   name: 'search',
  //   type: 'text',
  //   updateHandler: updateSearchTerm,
  //   validationResult: null,
  //   invalidLabel: false,
  //   onKeyDown: onSubmit,
  // };

  const handleClickBanner = () => {
    logEvent('Display', 'Clicked a Display', 'blogtracker');
  };

  return (
    <div className="col-span-12 lg:col-span-4 xl:col-span-3">
      <div className="sidebar-wrapper">
        <div className="sidebar-widget mb-8 hide-md">
          <a
            href={appUtils.getAppPath(locale, 'tutors')}
            onClick={handleClickBanner}
          >
            <Image
              height={800}
              width={800}
              alt="Display link to browsing tutors"
              src={bannerUrl}
            />
          </a>
        </div>
        <div className="sidebar-widget mb-8">
          <div className="search-form-wrapper">
            {/* <TextInput {...searchProps} /> */}
            <SearchInput
              onKeyDown={onSubmit}
              placeholder={t('sidebar.search.placeholder')}
              onSearch={onSubmit}
            />
          </div>
        </div>
        <div className="sidebar-widget mb-8">
          <div className="sidebar-about">
            <h3 className="sidebar__title mb-8">{t('sidebar.about.title')}</h3>
            <p className="mb-6">{t('sidebar.about.description')}</p>
            <a href={appUtils.getAppPath(locale, 'tutors')}>
              <Button type="button" className="w-full">
                {t('browseTutors')}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesSidebar;
